module.exports = __webpack_public_path__ + "img/kp59hover.54787545.png";